module.exports = __webpack_public_path__ + "86c8d39bdf66e70edc2af70191207d63.svg";